import type { ColumnsType } from 'antd/lib/table'
import { IntegrationPurchase } from '../models/myIntegrations.model'
import { getBuyerDataOrdered, getIntegrationPurchaseBuyerData } from '../helpers'
import {
  FormLabels,
  CustomText,
  CustomHeaderText,
  CustomProjectColumn,
  MyIntegrationListPurchaseAmountColumn,
  IntegrationPurchaseCertificateColumn,
  IntegrationPurchaseMovileViewColumn
} from 'src/components'

const integrationPurchaseListColumns: ColumnsType<IntegrationPurchase> = [
  {
    title: () => <CustomHeaderText text={'developers.Project'} />,
    responsive: ['sm'],
    sorter: (a: IntegrationPurchase, b: IntegrationPurchase) => {
      return a.buyer_data.email.length - b.buyer_data.email.length
    },
    sortDirections: ['descend', 'ascend'],
    render: (_, record) => <CustomProjectColumn name={record.name} imageSource={record.project_image} />
  },
  {
    title: () => <CustomHeaderText text={'developers.User'} />,
    responsive: ['sm'],
    sorter: (a: IntegrationPurchase, b: IntegrationPurchase) => getBuyerDataOrdered(a, b),
    sortDirections: ['descend', 'ascend'],
    render: (_, record) => {
      return (
        <div style={{ marginBottom: '-10px' }}>
          <FormLabels
            title={getIntegrationPurchaseBuyerData(record)}
            subtitle={record.buyer_data.email}
          />
        </div>
      )
    }
  },
  {
    title: () => <CustomHeaderText text={'menuItems.TransactionSummary'} />,
    responsive: ['sm'],
    sorter: (a: IntegrationPurchase, b: IntegrationPurchase) => a.amount - b.amount,
    sortDirections: ['descend', 'ascend'],
    render: (_, record) => {
      return (
        <MyIntegrationListPurchaseAmountColumn
          symbol={record.currency_symbol}
          amount={record.amount}
          co2_amount={record.co2_amount}
        />
      )
    }
  },
  {
    title: () => <CustomHeaderText text={'card.Certificate'} isCentered />,
    responsive: ['sm'],
    render: (_, record) => <IntegrationPurchaseCertificateColumn purchase={record} />
  },
  {
    title: () => <CustomHeaderText text={'developers.Date'} isCentered />,
    responsive: ['sm'],
    sorter: (a, b) => {
      const dateA = new Date(a.created)
      const dateB = new Date(b.created)
      return dateA.getTime() - dateB.getTime()
    },
    render: (_, record) => {
      return (
        <div className='centered-div'>
          <CustomText label={record.created} type={null} />
        </div>
      )
    }
  },
  // Mobile View
  {
    title: () => <CustomHeaderText text={'Document.Purchase'} isCentered />,
    responsive: ['xs'],
    sorter: (a, b) => {
      const dateA = new Date(a.created)
      const dateB = new Date(b.created)
      return dateA.getTime() - dateB.getTime()
    },
    render: (_, record) => <IntegrationPurchaseMovileViewColumn purchase={record} />
  },
]

export default integrationPurchaseListColumns
